/** 简体中文翻译 - Mozi */
export const zh = {
  app: { name: 'Mozi', description: 'AI 智能体界面', copyright: 'Copyright © 2026 Mozi' },
  menu: {
    about: '关于 Mozi', settings: '设置...', hide: '隐藏 Mozi', quit: '退出 Mozi',
    file: '文件', newChat: '新建对话', newWindow: '新建窗口',
    edit: '编辑', undo: '撤销', redo: '重做', cut: '剪切', copy: '复制', paste: '粘贴', selectAll: '全选',
    view: '视图', zoomIn: '放大', zoomOut: '缩小', resetZoom: '重置缩放',
    toggleFocusMode: '切换专注模式', toggleSidebar: '切换侧边栏',
    window: '窗口', minimize: '最小化', maximize: '最大化',
    help: '帮助', helpDocs: '帮助与文档', keyboardShortcuts: '键盘快捷键',
    checkForUpdates: '检查更新…', installUpdate: '安装更新…',
    debug: '调试', resetToDefaults: '恢复默认设置...', reload: '重新加载', forceReload: '强制重新加载',
    toggleDevTools: '切换开发者工具', craftMenu: 'Mozi 菜单',
    newSessionInPanel: '在面板中新建会话', newBrowserWindow: '新建浏览器窗口',
    sources: '数据源', skills: '技能', statuses: '状态',
    permissions: '权限', automations: '自动化', allDocumentation: '所有文档',
    back: '返回', forward: '前进',
  },
  sidebar: {
    openInNewWindow: '在新窗口中打开', markAllRead: '全部标为已读',
    configureStatuses: '配置状态', addNewLabel: '添加新标签',
    editLabels: '编辑标签', deleteLabel: '删除标签',
    editViews: '编辑视图', deleteView: '删除视图',
    addSource: '添加数据源', addSkill: '添加技能', addAutomation: '添加自动化',
    learnMoreAPIs: '了解更多关于 API', learnMoreMCP: '了解更多关于 MCP',
    learnMoreLocalFolders: '了解更多关于本地文件夹',
    learnMoreSources: '了解更多关于数据源', learnMoreAutomations: '了解更多关于自动化',
    subNavigation: '子导航', mainNavigation: '主导航',
  },
  settings: {
    app: { label: '应用', description: '通知和更新' },
    ai: { label: 'AI', description: '模型、思考、连接' },
    appearance: { label: '外观', description: '主题、字体、工具图标' },
    input: { label: '输入', description: '发送键、拼写检查' },
    workspace: { label: '工作区', description: '名称、图标、工作目录' },
    permissions: { label: '权限', description: '探索模式规则' },
    labels: { label: '标签', description: '管理会话标签' },
    server: { label: '服务器', description: '远程服务器访问' },
    shortcuts: { label: '快捷键', description: '键盘快捷键' },
    preferences: { label: '偏好设置', description: '用户偏好设置' },
    'im-binding': { label: '绑定 IM', description: '微信及 IM 集成' },
    language: '语言', languageDescription: '选择显示语言',
    notifications: '通知', desktopNotifications: '桌面通知',
    desktopNotificationsDesc: '当 AI 完成对话中的工作时发送通知。',
    power: '电源', keepScreenAwake: '保持屏幕常亮',
    keepScreenAwakeDesc: '在会话运行时防止屏幕关闭。',
    tools: '工具', builtInBrowser: '内置浏览器',
    builtInBrowserDesc: '如果你使用 Playwright、Puppeteer 或浏览器 MCP 服务器等外部浏览器工具，请禁用此选项。',
    network: '网络', httpProxy: 'HTTP 代理',
    httpProxyDesc: '通过代理服务器路由网络流量。', bypassRules: '绕过规则',
    about: '关于', version: '版本', checkForUpdates: '检查更新',
    checkNow: '立即检查', checking: '检查中...', saving: '保存中...', save: '保存', reset: '重置',
    updateReady: '更新就绪', restartToUpdate: '重启以更新到 v',
    downloading: '正在下载', openInNewWindow: '在新窗口中打开',
    installingUpdate: '正在安装更新...', appWillRestart: '应用将自动重启。',
    failedToInstallUpdate: '安装更新失败',
    upToDate: '已是最新版本', versionIsLatest: '版本 {{version}} 已是最新。',
    failedToCheckUpdates: '检查更新失败',
    updateVersionReady: '更新 v{{version}} 已就绪', restartToApply: '重启以应用更新。',
    restart: '重启',
    credentialIssue: '检测到凭据问题',
    credentialIssueDesc: '检测到凭据问题，请重新认证。',
    reAuthenticate: '重新认证', rename: '重命名', setAsDefault: '设为默认',
    edit: '编辑', validateConnection: '验证连接', delete: '删除',
    connectionValid: '连接有效', validating: '验证中...', validationFailed: '验证失败',
    notAuthenticated: '未认证', default: '默认', usingDefaults: '使用默认值',
    connection: '连接', connectionDesc: '新对话的 API 连接',
    model: '模型', modelDesc: '新对话的 AI 模型',
    thinking: '思考', thinkingDesc: '新对话的推理深度',
    // 思考级别选项
    thinkingOff: '关闭思考', thinkingOffDesc: '最快响应，不进行推理',
    thinkingLow: '低', thinkingLowDesc: '轻度推理，响应更快',
    thinkingMedium: '中', thinkingMediumDesc: '速度与推理的平衡',
    thinkingHigh: '高', thinkingHighDesc: '深度推理，适合复杂任务',
    thinkingMax: '最大', thinkingMaxDesc: '最大推理深度',
    useDefault: '使用默认', inheritFromApp: '继承应用设置',
    mode: '模式', system: '跟随系统', light: '浅色', dark: '深色',
    colorTheme: '颜色主题', font: '字体', inter: 'Inter',
    workspaceThemes: '工作区主题', workspaceThemesDesc: '按工作区覆盖主题设置',
    interface: '界面', connectionIcons: '连接图标',
    connectionIconsDesc: '在会话列表和模型选择器中显示提供商图标',
    richToolDescriptions: '丰富的工具描述',
    richToolDescriptionsDesc: '为所有工具调用添加操作名称和意图描述，在会话中提供更丰富的活动上下文。',
    toolIcons: '工具图标', toolIconsDesc: '聊天活动中 CLI 命令旁显示的图标。',
    editFile: '编辑文件', editToolIcons: '编辑工具图标',
    searchTools: '搜索工具...', noToolIconMappings: '未找到工具图标映射',
    typing: '输入', autoCapitalisation: '自动大写',
    autoCapitalisationDesc: '输入消息时自动将首字母大写。',
    spellCheck: '拼写检查', spellCheckDesc: '输入时为拼写错误的单词添加下划线。',
    sending: '发送', sendMessageWith: '发送消息方式', sendMessageDesc: '发送消息的键盘快捷键',
    enterKey: 'Enter', enterDesc: '使用 Shift+Enter 换行',
    cmdEnter: '⌘ Enter', ctrlEnter: 'Ctrl+Enter', cmdEnterDesc: '使用 Enter 换行',
    workspaceSettings: '工作区设置', noWorkspaceSelected: '未选择工作区',
    workspaceInfo: '工作区信息', name: '名称', icon: '图标', change: '更改',
    uploading: '上传中...', renameWorkspace: '重命名工作区',
    enterWorkspaceName: '输入工作区名称...',
    defaultMode: '默认模式', controlWhatAiCanDo: '控制 AI 的操作权限',
    readOnly: '只读，不允许更改', promptsBeforeEdits: '编辑前提示确认',
    fullAutonomous: '完全自主执行',
    modeCycling: '模式切换', modeCyclingDesc: '选择使用 Shift+Tab 循环切换的模式',
    atLeast2Modes: '至少需要 2 个模式',
    defaultSources: '默认数据源', defaultSourcesDesc: '新会话自动启用的数据源',
    noSourcesConfigured: '此工作区未配置数据源。',
    advanced: '高级', defaultWorkingDir: '默认工作目录',
    notSet: '未设置（使用会话文件夹）', clear: '清除', changeDir: '更改...',
    localMcpServers: '本地 MCP 服务器', localMcpServersDesc: '启用 stdio 子进程服务器',
    modeExplore: '探索', modeExploreDesc: '只读探索。阻止写入，不会提示。',
    modeAsk: '询问后编辑', modeAskDesc: '编辑前提示确认。',
    modeExecute: '执行', modeExecuteDesc: '自动执行，不提示。',
    aboutPermissions: '关于权限',
    aboutPermissionsDesc: '权限控制智能体的自主程度。在探索模式下，智能体只能读取和研究——非常适合在提交更改之前理解问题。准备好后，切换到执行模式让智能体自主实施计划。',
    goodWorkflow: '推荐工作流程：先在探索模式下让智能体调查，审查提出的计划，然后自信地执行。',
    learnMore: '了解更多',
    defaultPermissions: '默认权限',
    defaultPermissionsDesc: '探索模式下允许的应用级模式。不在此列表中的命令将被阻止。',
    noDefaultPermissions: '未找到默认权限。',
    workspaceCustomizations: '工作区自定义',
    workspaceCustomizationsDesc: '扩展上述应用默认值的工作区级模式。',
    noCustomPermissions: '未配置自定义权限。',
    listNavigation: '列表导航', navigateItems: '在列表中导航项目',
    goToFirst: '跳到第一项', goToLast: '跳到最后一项',
    sessionList: '会话列表', focusChatInput: '聚焦聊天输入',
    openContextMenu: '打开上下文菜单', addFilterExcluded: '添加为排除过滤器',
    chatInput: '聊天输入', sendMessage: '发送消息', newLine: '换行',
    closeDialogBlur: '关闭对话框 / 取消聚焦',
    // AI 页面额外项
    defaultDesc: '未设置工作区覆盖时，新对话使用的设置。',
    workspaceOverrides: '工作区覆盖', workspaceOverridesDesc: '按工作区覆盖默认设置。',
    connections: '连接', connectionsDesc: '管理你的 AI 提供商连接。',
    addConnection: '添加连接', renameConnection: '重命名连接',
    performance: '性能', performanceDesc: '费用和缓存选项。',
    extendedContext: '扩展上下文 (1M)',
    extendedContextDesc: '使用 Opus 4.6 的 1M token 上下文窗口。禁用以使用 200K 并节省使用限额。',
    extendedPromptCache: '扩展提示缓存（1 小时）',
    extendedPromptCacheDesc: '将提示缓存从 5 分钟延长到 1 小时。仅适用于通过 Anthropic API 的 Claude 模型。',
    // IM 绑定
    imBinding: {
      label: '绑定 IM', description: '微信及 IM 集成',
      pageTitle: '绑定 IM', pageDescription: '管理你的 IM 集成',
      // 微信集成卡片
      wechatTitle: '微信集成', wechatDescription: '连接你的微信账号，通过微信与 Mozi 对话。',
      statusUnbound: '未连接', statusBinding: '连接中...', statusBound: '已连接',
      statusError: '连接错误', statusRestoring: '正在恢复连接...',
      // 按钮
      configure: '配置', binding: '绑定中...', unbind: '解绑', retry: '重试',
      // 二维码面板
      qrWaitingToScan: '请使用微信扫描二维码进行绑定',
      qrScanned: '已扫码，请在手机上确认',
      qrExpired: '二维码已过期', qrError: '二维码加载失败',
      // 权限模式选择器
      permissionMode: '权限模式', permissionModeDescription: '控制智能体在微信会话中的操作权限',
      modeExplore: '探索', modeExploreDesc: '只读探索模式。智能体只能读取和研究。',
      modeAskToEdit: '询问后编辑', modeAskToEditDesc: '智能体在进行任何编辑前会先询问。',
      modeAuto: '自动', modeAutoDesc: '完全自主执行，无需确认。',
      // 解绑确认对话框
      unbindTitle: '解绑微信', unbindMessage: '确定要解绑微信账号吗？你可以选择保留或清除会话数据。',
      unbindAndClearData: '解绑并清除数据', unbindOnly: '仅解绑', cancel: '取消',
      // 账号信息
      accountLabel: '账号', boundStatus: '已绑定 {{accountId}}',
      // 错误信息
      errorStartLogin: '启动登录失败', errorGetStatus: '获取绑定状态失败',
      errorUnbind: '解绑失败', errorSetPermission: '设置权限模式失败',
      // 语音播放器
      voicePlayer: {
        play: '播放',
        pause: '暂停',
        audioUnavailable: '音频文件不可用',
        audioUnsupported: '音频格式不支持',
        loading: '加载中...',
        transcription: '转录文本',
        voiceMessage: '语音消息',
        voiceDownloadFailed: '语音下载失败',
        voiceReceiveFailed: '语音消息接收失败：无法下载语音文件',
      },
    },
  },
  shortcuts: {
    general: '通用', navigation: '导航', view: '视图', session: '会话',
    navigator: '导航器', chat: '聊天', panel: '面板',
    toggleTheme: '切换主题', focusSidebar: '聚焦侧边栏', focusNavigator: '聚焦导航器',
    focusChat: '聚焦聊天', focusNextZone: '聚焦下一区域',
    stopProcessing: '停止处理', cycleMode: '切换权限模式',
    clearSelection: '清除选择', focusNextPanel: '聚焦下一面板', focusPrevPanel: '聚焦上一面板',
    nextSearchMatch: '下一个搜索匹配', prevSearchMatch: '上一个搜索匹配',
  },
  onboarding: {
    defaultWorkspaceName: '我的工作区',
    updateSettings: '更新设置',
    welcome: '欢迎使用 Mozi',
    welcomeDesc: '智能体应有的用户体验。连接一切，组织你的会话。你需要的一切，尽在其中！',
    continue: '继续', getStarted: '开始使用',
    setupAgent: '设置你的智能体',
    setupAgentDesc: '选择你想如何驱动 AI 智能体。你可以稍后添加更多连接。',
    claudeProMax: 'Claude Pro/Max', claudeProMaxDesc: '使用你的 Claude 订阅获得无限访问。',
    anthropicApi: 'Anthropic API 密钥', anthropicApiDesc: '通过 Anthropic、OpenRouter 或兼容 API 按量付费。',
    chatgptPlus: 'ChatGPT Plus', chatgptPlusDesc: '使用你的 ChatGPT 订阅配合 Mozi 后端。',
    githubCopilot: 'GitHub Copilot', githubCopilotDesc: '使用你的 GitHub Copilot 订阅配合 Mozi 后端。',
    apiKey: 'API 密钥', apiKeyDesc: '通过 Mozi 后端使用提供商预设（Anthropic、OpenAI、Google 等）。',
    beta: '测试版',
    howToConnect: '你想如何连接？',
    claudeProMaxShort: 'Claude Pro / Max', claudeProMaxShortDesc: '使用你的 Anthropic 订阅。',
    codexChatgpt: 'Codex · ChatGPT Plus', codexChatgptDesc: '使用你的 ChatGPT Plus 或 Pro 订阅。',
    githubCopilotShort: 'GitHub Copilot', githubCopilotShortDesc: '使用你的 GitHub Copilot 订阅。',
    otherProvider: '我使用其他提供商', otherProviderDesc: 'Anthropic、AWS Bedrock、OpenRouter、Google 或任何兼容提供商。',
    localModel: '本地模型', localModelDesc: '使用 Ollama 在本地运行模型。',
    setupLater: '稍后设置',
    kiroSubscription: '使用 Kiro 订阅', kiroSubscriptionDesc: '使用你的 AWS Kiro 订阅。',
    connectKiro: '连接 Kiro', connectKiroDesc: '使用你的 Kiro 订阅驱动 Mozi。',
    signInKiro: '使用 Kiro 登录',
    enterCodeKiro: '在浏览器中输入此代码以授权：',
    kiroDeviceHint: '浏览器窗口应已打开 AWS 登录页面',
    clickToSignInKiro: '点击上方按钮使用你的 AWS 账户登录。',
    kiroConnected: '已连接！你的 Kiro 订阅已就绪。',
    connectChatgpt: '连接 ChatGPT', connectChatgptDesc: '使用你的 ChatGPT 订阅驱动 Mozi。',
    signInChatgpt: '使用 ChatGPT 登录',
    signInChatgptHint: '点击上方按钮使用你的 OpenAI 账户登录。将打开浏览器窗口进行认证。',
    connectedChatgpt: '已连接！你的 ChatGPT 订阅已就绪。',
    connectGithub: '连接 GitHub Copilot', connectGithubDesc: '使用你的 GitHub Copilot 订阅驱动 Mozi。',
    signInGithub: '使用 GitHub 登录',
    enterCodeGithub: '在 GitHub 上输入此代码以授权：', copiedToClipboard: '已复制到剪贴板',
    githubDeviceHint: '浏览器窗口应已打开 github.com/login/device',
    connectClaude: '连接 Claude 账户', connectClaudeDesc: '使用你的 Claude 订阅驱动多智能体工作流。',
    signInClaude: '使用 Claude 登录',
    enterAuthCode: '输入授权码', enterAuthCodeHint: '从浏览器页面复制代码并粘贴到下方。',
    cancel: '取消',
    apiConfig: 'API 配置',
    apiConfigDescPreset: '选择提供商预设并输入 API 密钥。对于任意 Anthropic 兼容端点，请使用 Anthropic API 密钥模式。',
    apiConfigDescKey: '输入你的 API 密钥。可选配置 OpenRouter、Ollama 或兼容 API 的自定义端点。',
    settingUp: '正在设置...', allSet: '一切就绪！',
    justStartChat: '开始对话，开始工作吧。',
    savingConfig: '正在保存你的配置...',
    sessionExpired: '会话已过期',
    sessionExpiredDesc: '你的会话已过期或不再有效。请重新登录以继续使用 Mozi。',
    conversationsPreserved: '你的对话和设置已保留。',
    logIn: '登录', loggingIn: '登录中...',
    resetAndStartFresh: '重置应用并重新开始...', loginFailed: '登录失败',
  },
  chat: {
    placeholder: '你想做什么？',
    shiftTabHint: '使用 Shift + Tab 在探索和执行模式之间切换',
    mentionHint: '输入 @ 提及文件、文件夹或技能',
    labelHint: '输入 # 为此对话添加标签',
    newLineHint: '按 Shift + Return 换行',
    toggleSidebarHint: '按 ⌘ + B 切换侧边栏',
    focusModeHint: '按 ⌘ + . 进入专注模式',
    include: '包含', exclude: '排除', clear: '清除',
    followUps: '后续问题', followUpAnnotations: '后续注释：',
    thinking: '思考中...', working: '工作中...', processing: '处理中...',
  },
  appErrors: {
    failedToLoadSessions: '加载会话失败',
    failedToLoadSessionsDesc: 'Mozi 可以连接，但加载会话列表失败。为避免隐藏真正的错误或数据问题，不会将其视为空工作区。',
    retryLoading: '重试加载会话',
    vcRedistMissing: '未找到 Microsoft Visual C++ Redistributable',
    vcRedistDesc: '文档工具（PDF、PPTX、DOCX、XLSX）需要它才能工作。安装后请重启。',
    install: '安装',
  },
  common: {
    cancel: '取消', confirm: '确认', save: '保存', delete: '删除', close: '关闭', ok: '确定',
    loading: '加载中...', error: '错误', success: '成功', search: '搜索', noResults: '无结果',
  },
  dialog: {
    resetTitle: '恢复默认设置',
    resetDetail: '要将 Mozi 恢复为默认设置，请退出应用并运行：\n\nbun run fresh-start\n\n这将删除所有配置、凭据、工作区和会话。',
    deleteConversationTitle: '删除对话',
    deleteConversationMessage: '确定要删除："{{name}}"？',
    deleteConversationDetail: '此操作无法撤销。',
    logOutTitle: '退出登录',
    logOutMessage: '确定要退出登录吗？',
    logOutDetail: '所有对话将被删除。此操作无法撤销。',
  },
  nav: {
    allSessions: '所有会话', flagged: '已标记', archived: '已归档',
    labels: '标签', sources: '数据源', skills: '技能', automations: '自动化',
    apis: 'API', mcps: 'MCP', localFolders: '本地文件夹',
    scheduled: '定时任务', eventBased: '事件驱动', agentic: '智能体',
    whatsNew: '最新动态', views: '视图',
    addSource: '添加数据源', addSkill: '添加技能', addAutomation: '添加自动化',
    noSourcesConfigured: '未配置数据源。', addSourcesInSettings: '在设置中添加数据源。',
    noApiSourcesConfigured: '未配置 API 数据源。',
    noMcpSourcesConfigured: '未配置 MCP 数据源。',
    noLocalSourcesConfigured: '未配置本地文件夹数据源。',
    noMatchingSources: '没有匹配的数据源。',
    sourcesEmptyDesc: '数据源将你的智能体连接到外部数据——MCP 服务器、REST API 和本地文件夹。',
    noSkillsConfigured: '未配置技能',
    skillsEmptyDesc: '技能是可复用的指令，教会你的智能体专门的行为。',
    noAutomationsConfigured: '未配置自动化',
    noAutomationsFound: '未找到自动化',
    automationsEmptyDesc: '自动化在事件发生时执行操作——按计划执行命令、响应标签变更或自动触发提示。',
    newSession: '新建会话',
    noSessionsYet: '暂无会话',
    noSessionsDesc: '与智能体的会话将显示在这里。开始一个新会话吧。',
    noArchivedSessions: '暂无归档会话',
    noArchivedSessionsDesc: '归档的会话将显示在这里。归档会话可以保持列表整洁，同时保留对话内容。',
  },
  labels: {
    title: '标签', aboutLabels: '关于标签',
    aboutLabelsDesc1: '标签帮助你用彩色标记组织会话。使用它们按项目、主题或优先级分类对话——方便后续筛选和查找相关会话。',
    aboutLabelsDesc2: '每个标签可以选择性地携带特定类型（文本、数字或日期）的值。这将标签变成结构化元数据。',
    aboutLabelsDesc3: '自动应用规则在消息匹配正则表达式模式时自动应用标签。',
    labelHierarchy: '标签层级',
    labelHierarchyDesc: '此工作区配置的所有标签。标签可以嵌套形成分组。',
    noLabelsConfigured: '未配置标签。',
    autoApplyRules: '自动应用规则',
    autoApplyRulesDesc: '当用户消息匹配时自动应用标签的正则表达式模式。',
  },
  preferences: {
    title: '偏好设置', basicInfo: '基本信息',
    basicInfoDesc: '帮助 Mozi 为你个性化回复。',
    nameLabel: '姓名', nameDesc: 'Mozi 如何称呼你。', namePlaceholder: '你的名字',
    timezone: '时区', timezoneDesc: '用于相对日期。', timezonePlaceholder: '例如 Asia/Shanghai',
    languageLabel: '语言', languageDesc: 'Mozi 回复的首选语言。', languagePlaceholder: '例如 中文',
    location: '位置', locationDesc: '启用位置感知回复，如天气、当地时间和地区上下文。',
    city: '城市', cityDesc: '你所在的城市，用于本地信息和上下文。', cityPlaceholder: '例如 上海',
    country: '国家', countryDesc: '你所在的国家，用于地区格式和上下文。', countryPlaceholder: '例如 中国',
    notes: '备注', notesDesc: '帮助 Mozi 了解你偏好的自由格式上下文。',
    notesPlaceholder: '你希望 Mozi 了解的任何额外信息...',
  },
  browser: {
    emptyTitle: '浏览器已就绪，等待你的智能体使用 ;)',
    emptyDescription: '让任意会话使用此浏览器（或打开另一个）来完成研究、表单填写、质量检查或数据提取等任务。',
    safetyHint: 'Mozi 仅在你要求时才会控制浏览器窗口。',
    showBrowserWindow: '显示浏览器窗口',
    openSessionUsingWindow: '打开使用此窗口的会话',
    openSessionWhichUsedWindow: '打开曾使用此窗口的会话',
    terminateBrowser: '终止浏览器',
    hideWindow: '隐藏窗口',
    closeWindowEntirely: '彻底关闭窗口',
    promptHN: 'HN：将前 10 条热门故事汇总为表格',
    promptProductHunt: 'Product Hunt：对比今日前 5 个产品',
    promptObservability: '可观测性定价矩阵（DD/New Relic/Grafana）',
    promptGitHub: 'GitHub 文档：最新 Actions 更新',
    promptUKPolicy: '英国政策动态：最新 5 条公告',
    promptBooking: 'Booking.com：下周末布达佩斯最佳住宿',
    promptKaggle: 'Kaggle：精选 8 个客户流失数据集',
    promptStatus: '状态快照：OpenAI/GitHub/Cloudflare',
    promptFigma: 'Figma 社区：热门设计系统',
    promptGoogle: 'Google 搜索文档：Core Web Vitals 清单',
  },
  workspace: {
    createWorkspace: '创建工作区',
    createWorkspaceDesc: '输入名称并选择工作区存储位置。',
    openFolder: '打开已有文件夹',
    openFolderDesc: '将已有文件夹作为工作区打开。',
    connectRemote: '连接远程服务器',
    createNew: '创建新工作区',
    chooseLocation: '选择位置',
    pickLocation: '选择新工作区的存放位置。',
    create: '创建', open: '打开', connect: '连接',
    creating: '创建中...', connecting: '连接中...',
    workspaceName: '工作区名称', enterName: '输入名称...',
    location: '位置', defaultLocation: '默认', customLocation: '自定义',
    browseFolder: '浏览...', selectFolder: '选择文件夹',
    serverUrl: '服务器地址', serverToken: '服务器令牌',
    back: '返回', cancel: '取消',
  },
  status: {
    backlog: '待办', todo: '待处理', needsReview: '待审核',
    done: '已完成', cancelled: '已取消', inProgress: '进行中',
  },
  session: {
    share: '分享', shared: '已分享', sendToWorkspace: '发送到工作区...',
    status: '状态', labels: '标签',
    flag: '标记', unflag: '取消标记',
    archive: '归档', unarchive: '取消归档',
    markAsUnread: '标为未读', rename: '重命名',
    regenerateTitle: '重新生成标题',
    openInNewPanel: '在新面板中打开', openInNewWindow: '在新窗口中打开',
    copyPath: '复制路径', delete: '删除',
    showInFinder: '在访达中显示',
    attachFiles: '附加文件', attach: '附加',
    oneFile: '1 个文件', nFiles: '个文件',
    chooseSources: '选择数据源', nSources: '个数据源',
    workInFolder: '工作文件夹', folder: '文件夹',
    chooseFolder: '选择文件夹...', reset: '重置',
    filterFolders: '筛选文件夹...', noFoldersFound: '未找到文件夹',
    model: '模型', context: '上下文', tokensUsed: 'tokens 已使用',
    unavailable: '不可用', connectionDefault: '连接默认',
    connectionUnavailable: '连接不可用',
    connectionUnavailableDesc: '此会话使用的连接已被移除。请创建新会话以继续。',
    using: '使用',
    stopResponse: '停止响应', sendMessage: '发送消息',
    contextUsed: '上下文已使用', clickToCompact: '点击压缩',
    waitForOperation: '等待当前操作完成',
    copySessionLink: '复制会话链接', unshare: '取消分享',
    copied: '已复制！',
    openInBrowser: '在浏览器中打开', copyLink: '复制链接',
    updateShare: '更新分享', stopSharing: '停止分享', shareOnline: '在线分享',
    sessionInfo: '会话信息', title: '标题', untitled: '未命名',
    sessionFiles: '会话文件',
    viewInFileManager: '在{{fileManager}}中查看',
    showInFileManager: '在{{fileManager}}中显示',
    filesEmptyHint: '此对话中附加或创建的文件将显示在这里。',
    sessionDeleted: '会话已删除',
    sessionFlagged: '会话已标记',
    addedToFlagged: '已添加到标记项目',
    flagRemoved: '已取消标记',
    removedFromFlagged: '已从标记项目中移除',
    sessionArchived: '会话已归档',
    movedToArchive: '已移至归档',
    sessionRestored: '会话已恢复',
    movedFromArchive: '已从归档中移出',
    undo: '撤销',
  },
  filter: {
    group: '分组', date: '日期', status: '状态',
    noMatching: '没有匹配的状态或标签',
    filterChats: '筛选对话', clear: '清除',
    statuses: '状态', labels: '标签',
  },
  editPopover: {
    describeChange: '描述你想要的更改...',
    whatToConnect: '你想连接什么？',
    whatApiToConnect: '你想连接什么 API？',
    whatMcpToConnect: '你想连接什么 MCP 服务器？',
    whatFolderToConnect: '你想连接什么文件夹？',
    whatToLearn: '我应该学会做什么？',
    whatLabelToCreate: '你想创建什么标签？',
    exampleConnectMcp: '例如："连接到 Linear"',
    exampleConnectApi: '例如："连接到 OpenAI API"',
    exampleConnectFolder: '例如："连接到我的 Obsidian 笔记库"',
    exampleAddSkill: '例如："按照代码规范审查 PR"',
    compactEmptyTitle: '你想做什么更改？',
    compactEmptySubtitle: '描述一下，剩下的交给我',
    compactPlaceholder1: '告诉我你想改什么',
    compactPlaceholder2: '描述你要的更新',
    compactPlaceholder3: '需要我修改什么？',
    examplePrefix: '例如',
  },
  credentials: {
    connectChatgpt: '连接 ChatGPT',
    connectChatgptDesc: '使用你的 ChatGPT 订阅驱动 Mozi。',
    connecting: '连接中...',
    signInChatgpt: '使用 ChatGPT 登录',
    chatgptHint: '点击上方按钮使用你的 OpenAI 账户登录。将打开浏览器窗口进行认证。',
    chatgptConnected: '已连接！你的 ChatGPT 订阅已就绪。',
    connectCopilot: '连接 GitHub Copilot',
    connectCopilotDesc: '使用你的 GitHub Copilot 订阅驱动 Mozi。',
    waitingAuth: '等待授权...',
    signInGithub: '使用 GitHub 登录',
    enterCodeGithub: '在 GitHub 上输入此代码以授权：',
    copiedToClipboard: '已复制到剪贴板',
    githubDeviceHint: '浏览器窗口应已打开 github.com/login/device',
    clickToSignIn: '点击上方按钮使用你的 GitHub 账户登录。',
    copilotConnected: '已连接！你的 GitHub Copilot 订阅已就绪。',
    enterAuthCode: '输入授权码',
    enterAuthCodeDesc: '从浏览器页面复制代码并粘贴到下方。',
    cancel: '取消',
    connectClaude: '连接 Claude 账户',
    connectClaudeDesc: '使用你的 Claude 订阅驱动多智能体工作流。',
    signInClaude: '使用 Claude 登录',
    apiConfig: 'API 配置',
    apiConfigDescPi: '选择提供商预设并输入 API 密钥。对于任意 Anthropic 兼容端点，请使用 Anthropic API 密钥模式。',
    apiConfigDescAnthropic: '输入你的 API 密钥。可选配置 OpenRouter、Ollama 或兼容 API 的自定义端点。',
    validating: '验证中...',
    pasteAuthCode: '在此粘贴你的授权码',
    apiKey: 'API 密钥', baseUrl: '基础 URL', model: '模型',
    models: '模型列表', optional: '可选',
    provider: '提供商', endpoint: '端点',
    protocol: '协议',
    apiKeyPlaceholder: '在此粘贴你的密钥...',
    modelPlaceholder: '模型 ID（可选）',
    modelsPlaceholder: '例如 model-a, model-b',
    endpointPlaceholder: 'https://your-endpoint.com/v1',
    accessKeyId: '访问密钥 ID', secretAccessKey: '秘密访问密钥', region: '区域',
  },
} as const
